import { Products } from './product';
import gaussRound from './gaussRound';

export class Basket {
    token: string = ''
    note: string = ''
    timestamp: number = Date.now()
    ID: number = Date.now()
    //версия корзины на сервере, поверх которой сделаны изменения; undefined - неизвестна (или сервер без версий)
    version: number | undefined = undefined
    get original_total_price() {
        return gaussRound(this.items.length ? this.items.reduce((acc: number, item) => {
            return acc + item.original_line_price
        }, 0) : 0, 2)
    }
    get total_price() {
        return (new Intl.NumberFormat('ru', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })).format(this.original_total_price);
    }
    get total_price_pofaktu() {
        return gaussRound(this.items.length ? this.items.reduce((acc: number, item) => {
            return acc + item.Цена_по_факту
        }, 0) : 0, 2)
    }
    get item_count() {
        return this.items ? this.items.length : 0;
    }
    items: Products = []

    toJSON() {
        const jsonObj: any = Object.assign({}, this);
        const proto = Object.getPrototypeOf(this);
        for (const key of Object.getOwnPropertyNames(proto)) {
            const desc = Object.getOwnPropertyDescriptor(proto, key);
            const hasGetter = desc && typeof desc.get === 'function';
            if (hasGetter) {
                jsonObj[key] = (this as any)[key];
            }
        }
        return jsonObj;
    }
}